<template>
    <header class="header-global">

 
        <base-nav class="navbar-main bg-primary header-fixed" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="/img/brand/logo-white-3.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="https://www.universal-tech.com">
                        <img src="img/brand/logo-dark.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <NavLinks></NavLinks>
            <SocialNavLinks></SocialNavLinks>
        </base-nav>
    </header>
</template>
<script>
    import BaseNav from "@/components/BaseNav";
    import BaseDropdown from "@/components/BaseDropdown";
    import CloseButton from "@/components/CloseButton";
    import SocialNavLinks from "./SocialNavLinks";
import NavLinks from "./NavLinks";

    export default {
        components: {
            BaseNav,
            CloseButton,
            BaseDropdown,
            SocialNavLinks,
            NavLinks
        }
    };
</script>
<style scoped>

.header-fixed
{
    position:fixed;
    top:0;
}

</style>
